import React from 'react';
import { bands } from '../data/content';
import { BANDS_SECTION_ID } from '../utils/scroll';
import { CourtMotif } from './icons/HandballMarks';
export function Bands() {
  return <section id={BANDS_SECTION_ID} className="scroll-mt-4 bg-slate-50 px-5 py-16 sm:py-20" data-id="element-16" data-mp="hj29ajps086e">
      <div className="mx-auto max-w-6xl" data-id="element-17" data-mp="di9znpczs19l">
        <div className="mx-auto max-w-2xl text-center" data-id="element-18" data-mp="dh78dgbrbwt5">
          <h2 className="font-display text-3xl font-black leading-tight text-navy-800 sm:text-4xl" data-id="element-19" data-mp="8j5rn21t09ku">
            Die sechs Bände im Überblick
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-slate-600 sm:text-base" data-id="element-20" data-mp="3puhaqxs9ao6">
            Jeder Band ist ein eigenes PDF mit 60 Seiten und einem klaren
            Schwerpunkt.
          </p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-21" data-mp="3pxauv7tvryp2">
          {bands.map((band, index) => <article key={band.number} className="flex h-full flex-col rounded-xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-22" data-mp="3gyh623mskcm2" data-mpi={index}>
              <div className="flex items-start justify-between gap-4" data-id="element-23" data-mp="3lb9cbr9fheeo">
                <div data-id="element-24" data-mp="3q4udfs6bioi3">
                  <p className="font-display text-xs font-black uppercase tracking-[0.16em] text-gold-dark" data-id="element-25" data-mp="3q5doqq1gqen5">
                    Band {band.number}
                  </p>
                  <p className="mt-1 text-xs font-semibold text-slate-500" data-id="element-26" data-mp="3gf2hatiklnbi">
                    {band.group} · {band.age}
                  </p>
                </div>
                <CourtMotif variant={index + 1} className="h-12 w-auto shrink-0 text-navy-800/25" data-id="element-27" data-mp="cxahwu23u13a" />
              </div>

              <h3 className="mt-5 font-display text-lg font-extrabold leading-snug text-navy-800" data-id="element-28" data-mp="3v59tirhzia3r">
                {band.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600" data-id="element-29" data-mp="2jnqpwy0hs54o">
                {band.focus}
              </p>

              <p className="mt-auto pt-6 text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400" data-id="element-30" data-mp="2ooo99dx8n57r">
                PDF · 60 Seiten
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}